import { all, takeLatest } from 'redux-saga/effects'
import store from '../../store'
import { actions } from './Items.slice'
import { paginate } from './Items.thunk'

function paginateItems () {
  store.dispatch(paginate() as any)
}

export default function * effects () {
  yield all([
    takeLatest(actions.replaceLimit, paginateItems),
    takeLatest(actions.replacePage, paginateItems),
    takeLatest(actions.replaceSearch, paginateItems)
  ])
}
